import { InlineEditor } from "./InlineEditor";
import type { EditorProps } from "./editorProps";

/** Accepts `$1,234.50` and `(12.00)`; the value is rounded to cents. */
export const MoneyEditor = (props: EditorProps) => (
    <InlineEditor
        {...props}
        align="end"
        inputMode="decimal"
        placeholder="0.00"
    />
);
